import { render, staticRenderFns } from "./TrackingImpactionPointInputSides.vue?vue&type=template&id=06673e6a&scoped=true&"
import script from "./TrackingImpactionPointInputSides.vue?vue&type=script&lang=js&"
export * from "./TrackingImpactionPointInputSides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06673e6a",
  null
  
)

export default component.exports